module.exports = __webpack_public_path__ + "components/rewards/coolbus/static/logo-d0b077354b4afdba8ea61bcd4f00fa24.jpg";